import React, { useState, useContext } from 'react'
import RayIcon from '../../icons/Ray'
import PropTypes from 'prop-types'
import { EditDialog } from '../../dialogs/editDialog'
import { createPortal } from 'react-dom'
import { ProjectContext } from '../../../context/ProjectContext'

export function Problems({ problems }) {
  const [showEditDialog, setShowEditDialog] = useState(false)
  const [selectedProblem, setSelectedProblem] = useState(null)
  const { project, setProject, participants, meetings, setProblems } = useContext(ProjectContext)

  const handleDoubleClick = (problem) => {
    // Transform the overview problem data structure to match what EditDialog expects
    const transformedProblem = {
      id: problem.problem_number,
      content: problem.problem,
      title: problem.title,
      created_at: Date.now(),
      meetingId: meetings[0]?.id, // Use the first meeting as a fallback
      projectId: project.id
    }
    setSelectedProblem(transformedProblem)
    setShowEditDialog(true)
  }

  return (
    <div className="w-full bg-white rounded-xl p-8 shadow-sm border border-[#e4e4e4]">
      <div className='pb-8 border-b border-[#e4e4e4]'>
        <p className="text-[#3f424a] text-4xl font-bold font-['DM_Sans'] leading-[41.40px]">Pain Points</p>
      </div>

      <div className="mt-[36px] flex flex-wrap gap-[32px]">
        {problems.map((problem) => (
          <div
            key={problem.problem_number}
            className='w-[395px] px-[36px] pt-[24px] pb-[48px] bg-white rounded flex flex-col justify-center items-center gap-[16px] cursor-pointer'
            style={{ boxShadow: '0px 0px 22.399999618530273px rgba(14.96, 21.41, 55.25, 0.05)' }}
            onDoubleClick={() => handleDoubleClick(problem)}
          >
            <RayIcon />
            <p className="text-center text-black text-base font-extrabold font-['Manrope'] leading-normal tracking-wide">{problem.title}</p>
            <p className="text-center text-black text-sm font-semibold font-['Manrope'] leading-[19px] tracking-wide">{problem.problem}</p>
          </div>
        ))}
      </div>

      {showEditDialog && selectedProblem && createPortal(
        <EditDialog
          entity={selectedProblem}
          entityName={'problem'}
          project={project}
          participants={participants}
          rating={false}
          tagging={false}
          readOnly={true}
          setProject={setProject}
          setEntities={setProblems}
          meeting={meetings.find((meet) => meet.id === selectedProblem.meetingId) || {}}
          close={() => setShowEditDialog(false)}
        />,
        document.body
      )}
    </div>
  )
}

Problems.propTypes = {
  problems: PropTypes.array,
}
